import styled, { css } from "styled-components";
import convertHexToRgba from "~/helpers/convertHexToRgba";

const ReturnOfferStyled = styled.div.attrs({
  className: "return-offer-screen",
})`
  ${({ theme }) => {
    const { colors, media } = theme;

    return css`
      align-items: center;
      background-color: ${colors.primary.white};
      box-shadow: 0 1.25rem 2.5rem 0 ${convertHexToRgba(colors.primary.black, 0.25)};
      display: flex;
      flex-direction: column;
      min-width: 343px;
      width: 343px;
      border-radius: 32px;
      position: relative;
      font-weight: 700;
      text-align: center;

      ${media.tablet.up} {
        min-width: 45rem;
        width: 45rem;
        flex-direction: row;
        align-items: stretch;
        text-align: left;
      }

      ${media.desktop.up} {
        min-width: 1110px;
        width: 1110px;
      }

      .return-offer-screen {
        &__close-button {
          position: absolute;
          top: 0;
          right: 0;
          cursor: pointer;
          height: 45px;
          width: 45px;
          padding: 1rem;
          z-index: 10;

          ${media.tablet.up} {
            height: 60px;
            width: 60px;
            padding: 1.25rem;
          }
        }

        &__content-section {
          width: 100%;
          padding: 3.75rem 2rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex: 1;

          ${media.tablet.up} {
            width: 50%;
            align-items: center;
            padding: 3.75rem 2.5rem;
            order: 1;
          }
        }

        &__pre-header {
          display: flex;
          align-items: center;
          margin-bottom: 2rem;
          font-size: 0.875rem;
          font-weight: 600;
          letter-spacing: 1px;
          background-color: ${colors.primary.neutralLight};
          border-radius: 0.625rem;
          border: 2px solid ${colors.secondary.gray};
          padding: 0.625rem 0.75rem;
        }

        &__offer-icon {
          width: 1.25rem;
          height: 1.25rem;
          margin-right: 0.5rem;
          color: ${colors.primary.red};
        }

        &__heading {
          text-align: center;
          max-width: 530px;
          font-size: 1.25rem;
          line-height: 1.2;
          margin-bottom: 1rem;
          color: ${colors.primary.black};

          ${media.tablet.up} {
            font-size: 1.875rem;
            margin-bottom: 1.5rem;
          }
        }

        &__red-strikethrough {
          position: relative;
          color: ${colors.primary.black};
          font-weight: 700;
          text-decoration: none;

          &::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 0;
            right: 0;
            height: 2px;
            background-color: ${colors.primary.red};
            transform: translateY(-50%);
          }
        }

        &__subheading {
          font-size: 1rem;
          line-height: 1.5;
          font-weight: 700;
          margin-bottom: 2rem;
          text-align: center;

          ${media.tablet.up} {
            font-size: 1.125rem;
            margin-bottom: 2.5rem;
          }
        }

        &__tooltip-icon {
          width: 1.25rem;
          height: 1.25rem;
          color: ${colors.primary.black};
          display: inline-flex;
          vertical-align: middle;
          margin-left: 0.25rem;
          position: relative;
          top: -0.1em;
        }

        &__address {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          font-size: 1rem;
          font-weight: 700;
          margin-bottom: 2rem;

          ${media.tablet.up} {
            flex-direction: row;
            align-items: center;
            margin-bottom: 2.5rem;
          }
        }

        &__address-label {
          display: flex;
          align-items: center;
          margin-bottom: 0.25rem;

          ${media.tablet.up} {
            margin-bottom: 0;
            margin-right: 0.5rem;
          }
        }

        &__address-icon {
          margin-right: 0.5rem;
        }

        &__btn {
          width: 100%;
          min-height: 3.5rem;
          font-size: 1rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;

          ${media.tablet.up} {
            width: auto;
            min-width: 200px;
            padding: 0 2rem;
          }
        }
      }
    `;
  }};
`;

export default ReturnOfferStyled;
